import { render, staticRenderFns } from "./jsaDetail.vue?vue&type=template&id=637f99e6"
import script from "./jsaDetail.vue?vue&type=script&lang=js"
export * from "./jsaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637f99e6')) {
      api.createRecord('637f99e6', component.options)
    } else {
      api.reload('637f99e6', component.options)
    }
    module.hot.accept("./jsaDetail.vue?vue&type=template&id=637f99e6", function () {
      api.rerender('637f99e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/jsa/jsaDetail.vue"
export default component.exports